import { fromJS } from "immutable";
import ACTIONS from "../constants";

const initialState = fromJS({
  shift: {},
  shifts: [],
  pageLoading: false,
  loading: false,
  shiftsPagination: {},
  error: "",
});

export default function shiftReducer(state = initialState, action) {
  switch (action.type) {
    case ACTIONS.SHIFTS.PENDING: {
      return state.set("error", "").set("pageLoading", true);
    }
    case ACTIONS.SHIFTS.SUCCESS: {
      return state
        .set("error", "")
        .set("shifts", action.data.data)
        .set("shiftsPagination", action.data.pagination)
        .set("pageLoading", false);
    }
    case ACTIONS.SHIFTS.ERROR: {
      return state.set("error", action.error).set("pageLoading", false);
    }

    // CREATE SHIFT
    case ACTIONS.CREATE_SHIFT.PENDING: {
      return state.set("error", "").set("loading", true);
    }
    case ACTIONS.CREATE_SHIFT.SUCCESS: {
      return state
        .set("error", "")
        .set("loading", false)
        .set("shifts", action.data.data)
        .set("shiftsPagination", action.data.pagination);
    }
    case ACTIONS.CREATE_SHIFT.ERROR: {
      return state.set("error", action.error).set("loading", false);
    }

    // UPDATE SHIFT
    case ACTIONS.UPDATE_SHIFT.PENDING: {
      return state.set("error", "").set("loading", true);
    }
    case ACTIONS.UPDATE_SHIFT.SUCCESS: {
      return state
        .set("error", "")
        .set("loading", false)
        .set("shifts", action.data.data)
        .set("shiftsPagination", action.data.pagination);
    }
    case ACTIONS.UPDATE_SHIFT.ERROR: {
      return state.set("error", action.error).set("loading", false);
    }

    // DELETE SHIFT
    case ACTIONS.DELETE_SHIFT.PENDING: {
      return state.set("error", "").set("loading", true);
    }
    case ACTIONS.DELETE_SHIFT.SUCCESS: {
      return state
        .set("error", "")
        .set("loading", false)
        .set("shifts", action.data.data)
        .set("shiftsPagination", action.data.pagination);
    }
    case ACTIONS.DELETE_SHIFT.ERROR: {
      return state.set("error", action.error).set("loading", false);
    }

    case ACTIONS.SORT_SHIFT.PENDING: {
      return state.set("error", "");
    }
    case ACTIONS.SORT_SHIFT.SUCCESS: {
      return state
        .set("error", "")
        .set("shifts", action.data.data)
        .set("shiftsPagination", action.data.pagination);
    }
    case ACTIONS.SORT_SHIFT.ERROR: {
      return state.set("error", action.error);
    }

    case ACTIONS.ASSIGN_SHIFT.PENDING: {
      return state.set("error", "").set("loading", true);
    }
    case ACTIONS.ASSIGN_SHIFT.SUCCESS: {
      return state.set("error", "").set("loading", false);
    }
    case ACTIONS.ASSIGN_SHIFT.ERROR: {
      return state.set("error", action.error);
    }

    default: {
      return state;
    }
  }
}
